"use client";

import Image from "next/image";
import Link from "next/link";
import { useState } from "react";
import type { CardLine } from "@bash/shared/platform";
import { BANDS, LINES, LINE_TITLE, type Band } from "../_content/card";
import { Icon } from "../_family/Icon";
import { CARD_CAPTION } from "./words";

/** Each band in the colour of the teammate who owns that kind of work (landing.css paints each). */
export const BAND_COLOUR: Record<Band, string> = {
  setup: "bash",
  work: "scout",
  see: "quill",
  knows: "ledger",
  customers: "hunter",
  run: "keeper",
};

/** The card of eighteen (from card.ts): six bands, each command linking to its page, its words shown as you point. */
export function Card() {
  const [pointed, setPointed] = useState<CardLine | null>(null);
  const leave = () => setPointed(null);

  return (
    <div className="card-wrap dotfield rv d1">
      <div className="card18">
        <div className="card18-head">
          <svg className="mk" aria-hidden="true">
            <use href="#vf-mark" />
          </svg>
          <b>The Vestra card</b>
          <Link href={`/developers/${LINES[0]}`}>
            <span>Open the card</span>
            <Icon name="arrowRight" />
          </Link>
        </div>
        <div className="bands">
          {BANDS.map((band) => (
            <div key={band.id} className="band18" data-c={BAND_COLOUR[band.id]}>
              <h4>
                <i />
                {band.label}
              </h4>
              <div className="cmds">
                {band.lines.map((line) => (
                  <Link
                    key={line}
                    className="cmd"
                    href={`/developers/${line}`}
                    aria-label={`${line}: ${LINE_TITLE[line]}`}
                    onMouseEnter={() => setPointed(line)}
                    onFocus={() => setPointed(line)}
                    onMouseLeave={leave}
                    onBlur={leave}
                  >
                    {line}
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>
        <p className="card18-cap">
          {pointed ? (
            <>
              <code>{pointed}</code>
              <span>{LINE_TITLE[pointed]}</span>
            </>
          ) : (
            CARD_CAPTION
          )}
        </p>
      </div>
      <div className="mascot" aria-hidden="true">
        <Image
          src="/developers/family/mascot-scout.webp"
          width={311}
          height={600}
          alt=""
          unoptimized
        />
      </div>
    </div>
  );
}
